import { getFluidGatsbyImage } from 'gatsby-source-sanity'

export default (image, options) => {
    return getFluidGatsbyImage(image, options, {
        projectId: process.env.GATSBY_SANITY_PROJECT_ID,
        dataset: 'production'
    })
}